import api from "./ApiClient";

const BASE_PATH = '/foodz/api/v1/gerenciamentoDeUsuario';

class CustomerService {
  static async registerStudent(client) {
    const response = await api.post(
      `${BASE_PATH}/cadastrarAluno`,
      client
    );
    return response.data;
  }

  static async registerParent(parent) {
    const response = await api.post(
      `${BASE_PATH}/cadastrarResponsavel`,
      parent
    );
    return response.data;
  }

  static async registerEmployee(client) {
    const response = await api.post(
      `${BASE_PATH}/cadastrarColaborador`,
      client
    );
    return response.data;
  }

  static async getAllStudents(params = {}) {
    const clientCode = sessionStorage.getItem("clientCode");

    const {
      search,
      page,
      size,
      sort,
      ...filters
    } = params;

    const sortValue = Array.isArray(sort)
      ? (sort.length ? sort : undefined)
      : (sort?.trim() || undefined);

    const requestParams = {
      clientCode,
      ...(search && { search }),
      ...(page !== undefined && { page }),
      ...(size && { size }),
      ...(sortValue !== undefined && { sort: sortValue }),
      ...filters,
    };

    const response = await api.get(
      `${BASE_PATH}/listarTodosAlunos`,
      { params: requestParams }
    );

    return response.data;
  }

  static async getSpecificStudent(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/pesquisarAluno`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async checkStudentPin(login, pinCode) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/checarPinCompra`,
      { params: { clientCode, login, pinCode } }
    );
    return response.data;
  }

  static async getAllParents(params = {}) {
    const clientCode = sessionStorage.getItem('clientCode');

    const {
      search,
      page,
      size,
      pageSize,
      sort,
      ...filters
    } = params;

    const sizeToSend = size || pageSize;
    const sortValue = Array.isArray(sort)
      ? (sort.length ? sort : undefined)
      : (sort?.trim() || undefined);

    const requestParams = {
      clientCode,
      ...(search && { search }),
      ...(page !== undefined && { page }),
      ...(sizeToSend && { size: sizeToSend }),
      ...(sortValue !== undefined && { sort: sortValue }),
      ...filters,
    };

    const response = await api.get(
      `${BASE_PATH}/listarTodosResponsaveis`,
      { params: requestParams }
    );
    return response.data;
  }

  static async getSpecificParent(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/pesquisarResponsavel`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async getParentsListByParameter(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/pesquisarResponsaveis`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async getAllEmployees(params = {}) {
    const clientCode = sessionStorage.getItem("clientCode");

    const {
      search,
      page,
      size,
      sort,
      ...filters
    } = params;

    const sortValue = Array.isArray(sort)
      ? (sort.length ? sort : undefined)
      : (sort?.trim() || undefined);

    const requestParams = {
      clientCode,
      ...(search && { search }),
      ...(page !== undefined && { page }),
      ...(size && { size }),
      ...(sortValue !== undefined && { sort: sortValue }),
      ...filters,
    };

    const response = await api.get(
      `${BASE_PATH}/listarColaboradores`,
      { params: requestParams }
    );

    return response.data;
  }


  static async getSpecificEmployee(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/pesquisarColaborador`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async getStudentsByInput(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/pesquisarAlunos`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async findParentsByStudent(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/encontrarResponsaveis`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async findStudentsByParent(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/encontrarAlunos`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async updateStudent(searchInput, client) {
    const response = await api.put(
      `${BASE_PATH}/atualizarCadastroAluno`,
      client,
      { params: { searchInput } }
    );
    return response.data;
  }

  static async updateStudentCredit(login, customer, transaction) {
    const response = await api.put(
      `${BASE_PATH}/atualizarCreditoAluno`,
      { studentDTO: customer, transactionDTO: transaction },
      { params: { searchInput: login } }
    );
    return response.data;
  }

  static async returnStudentCredit(login, customer) {
    const response = await api.put(
      `${BASE_PATH}/retornarCreditoAluno`,
      customer,
      { params: { searchInput: login } }
    );
    return response.data;
  }

  static async updateEmployee(client) {
    const response = await api.put(
      `${BASE_PATH}/atualizarCadastroColaborador`,
      client,
    );
    return response.data;
  }

  static async updateEmployeeCredit(login, customer, transaction) {
    const response = await api.put(
      `${BASE_PATH}/atualizarCreditoColaborador`,
      { employeeDTO: customer, transactionDTO: transaction },
      { params: { searchInput: login } }
    );
    return response.data;
  }

  static async updateParent(searchInput, parent) {
    const response = await api.put(
      `${BASE_PATH}/atualizarCadastroResponsavel`,
      parent,
      { params: { searchInput } }
    );
    return response.data;
  }

  static async deleteStudent(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.delete(
      `${BASE_PATH}/removerAluno`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async deleteParent(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.delete(
      `${BASE_PATH}/removerResponsavel`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async deleteEmployee(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.delete(
      `${BASE_PATH}/removerColaborador`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async removeStudentsFromParentRecord(loginParent, studentId) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.delete(
      `${BASE_PATH}/removerAlunos`,
      { params: { clientCode, loginParent: loginParent, studentId: studentId } }
    );
    return response.data;
  }

  static async addParenting(parentId, studentId) {
    const clientCode = sessionStorage.getItem("clientCode");

    const response = await api.post(
      `${BASE_PATH}/adicionarParentesco`,
      {},
      {
        params: {
          parentId,
          studentId,
          clientCode
        }
      }
    );

    return response.data;
  }

  static async updateBatchGrades(payload) {
    const clientCode = sessionStorage.getItem("clientCode");

    const response = await api.put(
      `${BASE_PATH}/atualizarSerieEmMassa`,
      payload,
      { params: { clientCode } }
    );
    return response.data;
  }

  static async updateBatchStatus(logins, isActive) {
    const clientCode = sessionStorage.getItem("clientCode");

    const payload = {
      logins: logins,
      active: isActive
    };

    const response = await api.put(
      `${BASE_PATH}/atualizarStatusEmMassa`,
      payload,
      { params: { clientCode } }
    );
    return response.data;
  }

  static async getStudentTurnPreferences(login) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(`${BASE_PATH}/aluno/turnos`, { params: { clientCode, login } });
    return response.data;
  }

  static async updateStudentTurnPreferences(login, turnIds) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.put(`${BASE_PATH}/aluno/turnos`, turnIds, { params: { clientCode, login } });
    return response.data;
  }
}

export default CustomerService;